import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import TextAutoResize from "../TextAutoResize";

const ChatInput = ({
	classActive,
	disabledChat,
	handleOnChange,
	handleKeyDown,
	inputMessage,
	handleMessageSend,
	chatError,
	handleChatEnable,
}) => {
	if (chatError) {
		return (
			<div className="ClassroomChatMessagePane_controlsPaneDisabled">
				<p>{chatError}</p>
			</div>
		);
	}

	if (!classActive) {
		return (
			<div className="ClassroomChatMessagePane_controlsPaneDisabled">
				<p>Chat is disabled until your class is online again.</p>
				<a href="https://docs.classwize.net/help/intro-classtools" target="_blank" rel="noopener noreferrer">
					Learn more
				</a>
			</div>
		);
	}

	if (disabledChat) {
		return (
			<div className="ClassroomChatMessagePane_controlsPaneDisabled">
				<p>Chat is currently turned off for this session.</p>
				<button className="ClassroomChatMessagePane_enableChat" onClick={handleChatEnable}>
					Turn on chat
				</button>
			</div>
		);
	}

	return (
		<div className="ClassroomChatMessagePane_controlsPane">
			<div
				className={clsx("ClassroomChatMessagePane_textInputWrapper", {
					"ClassroomChatMessagePane_textInput--hasContent": inputMessage.length,
				})}
			>
				<TextAutoResize
					autoComplete="off"
					className="ClassroomChatMessagePane_textInput"
					onChange={handleOnChange}
					placeholder="Type a message"
					value={inputMessage}
					disabled={disabledChat}
					onKeyDown={handleKeyDown}
				/>
			</div>
			<button
				className="ClassroomChatMessagePane_sendButton"
				disabled={disabledChat || !inputMessage.length || inputMessage.length >= 1000}
				onClick={handleMessageSend}
				type="button"
			>
				<i aria-hidden="true" className="fa fa-paper-plane ClassroomChatMessagePane_sendIcon" />
			</button>
		</div>
	);
};

ChatInput.propTypes = {
	classActive: PropTypes.bool,
	disabledChat: PropTypes.bool,
	handleOnChange: PropTypes.func,
	handleKeyDown: PropTypes.func,
	inputMessage: PropTypes.string,
	handleMessageSend: PropTypes.func,
	chatError: PropTypes.string,
	handleChatEnable: PropTypes.func,
};

export default ChatInput;
